(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5976],{

/***/ 65976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Form; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/scroll-into-view-if-needed/es/index.js + 1 modules
var es = __webpack_require__(75469);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(82492);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var _util_classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/setWith.js
var setWith = __webpack_require__(31921);
var setWith_default = /*#__PURE__*/__webpack_require__.n(setWith);
// EXTERNAL MODULE: ./node_modules/lodash/has.js
var has = __webpack_require__(18721);
var has_default = /*#__PURE__*/__webpack_require__.n(has);
// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__(57557);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeepWith.js
var cloneDeepWith = __webpack_require__(53888);
var cloneDeepWith_default = /*#__PURE__*/__webpack_require__.n(cloneDeepWith);
// EXTERNAL MODULE: ./node_modules/lodash/set.js
var set = __webpack_require__(36968);
var set_default = /*#__PURE__*/__webpack_require__.n(set);
// EXTERNAL MODULE: ./node_modules/b-validate/es/index.js + 11 modules
var b_validate_es = __webpack_require__(9085);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Form/utils.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};







function cloneDeep(value) {
    // 只有对象才执行拷贝，否则直接返回。 如果是 File，MouseEvent对象，都可以直接返回
    return cloneDeepWith_default()(value, function (val) {
        if (!(0,is/* isObject */.Kn)(val) && !(0,is/* isArray */.kJ)(val)) {
            return val;
        }
    });
}
var formatValidateMsg = function (validateMessages, info) {
    return cloneDeepWith_default()(validateMessages, function (val) {
        if ((0,is/* isFunction */.mf)(val)) {
            return function (data) {
                return val(data, info);
            };
        }
    });
};
function utils_set(target, field, value) {
    set_default()(target, field, cloneDeep(value));
    return target;
}
// iteratively get all keys of object including nested objects
// e.g. const myObj = { a: { b: { c: [1,2] } } }
// iterativelyGetKeys(myObj) returns ['a.b.c.0', 'a.b.c.1']
// reference https://stackoverflow.com/a/47063174
function iterativelyGetKeys(_obj, _prefix) {
    if (_prefix === void 0) { _prefix = ''; }
    var processed = new Set();
    var getKeys = function (obj, prefix) {
        if (prefix === void 0) { prefix = ''; }
        if (!obj) {
            return [];
        }
        // Avoid circular dependencies
        if (processed.has(obj)) {
            return [];
        }
        processed.add(obj);
        return Object.keys(obj).reduce(function (res, el) {
            if (((0,is/* isObject */.Kn)(obj[el]) || (0,is/* isArray */.kJ)(obj[el])) &&
                Object.keys(obj[el]).length &&
                !react.isValidElement(obj[el])) {
                return __spreadArray(__spreadArray([], __read(res), false), __read(getKeys(obj[el], prefix + el + ".")), false);
            }
            return __spreadArray(__spreadArray([], __read(res), false), [prefix + el], false);
        }, []);
    };
    return getKeys(_obj, _prefix);
}
// 判断是否是个事件对象 e?.constructor?.name 可能不是 SyntheticEvent，跟业务项目的打包方式有关系
function isSyntheticEvent(e) {
    var _a;
    return ((_a = e === null || e === void 0 ? void 0 : e.constructor) === null || _a === void 0 ? void 0 : _a.name) === 'SyntheticEvent' || (e === null || e === void 0 ? void 0 : e.nativeEvent) instanceof Event;
}
function schemaValidate(field, value, _rules, validateMessages) {
    return __awaiter(this, void 0, void 0, function () {
        var rules, current;
        var _this = this;
        return __generator(this, function (_a) {
            rules = __spreadArray([], __read(_rules), false);
            current = 0;
            return [2 /*return*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                    var warning, validate;
                    var _this = this;
                    return __generator(this, function (_a) {
                        warning = [];
                        validate = function (rule) { return __awaiter(_this, void 0, void 0, function () {
                            var next, _rule, schema;
                            var _a, _b;
                            return __generator(this, function (_c) {
                                next = function () {
                                    if (current < rules.length - 1) {
                                        current++;
                                        return validate(rules[current]);
                                    }
                                    return resolve({ error: null, warning: warning });
                                };
                                if (!rule) {
                                    return [2 /*return*/, next()];
                                }
                                _rule = __assign({}, rule);
                                if (!_rule.type && !_rule.validator) {
                                    _rule.type = 'string';
                                }
                                schema = new b_validate_es.Schema((_a = {}, _a[field] = [_rule], _a), {
                                    ignoreEmptyString: true,
                                    validateMessages: validateMessages,
                                });
                                schema.validate((_b = {}, _b[field] = value, _b), function (error) {
                                    if (error) {
                                        if (rule.validateLevel === 'warning') {
                                            warning.push(error[field].message);
                                        }
                                        else {
                                            return resolve({
                                                error: error,
                                                warning: warning,
                                            });
                                        }
                                    }
                                    return next();
                                });
                                return [2 /*return*/];
                            });
                        }); };
                        validate(rules[current]);
                        return [2 /*return*/];
                    });
                }); })];
        });
    });
}
function isFieldMatch(field, fields) {
    var fieldObj = setWith_default()({}, field, undefined, Object);
    return fields.some(function (item) { return has_default()(fieldObj, item); });
}
var ID_SUFFIX = '_input';

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Form/interface.js
/* eslint-disable @typescript-eslint/no-explicit-any */
// TS泛型默认值需要，忽略显式`any`定义
var VALIDATE_STATUS = {
    error: 'error',
    success: 'success',
    warning: 'warning',
    validating: 'validating',
};
var SubmitStatus;
(function (SubmitStatus) {
    SubmitStatus["init"] = "init";
    SubmitStatus["error"] = "error";
    SubmitStatus["success"] = "success";
    SubmitStatus["submitting"] = "submitting";
})(SubmitStatus || (SubmitStatus = {}));

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Form/promisify.js
// https://github.com/RyanZim/universalify/blob/master/index.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// form validate error
var ValidateError = /** @class */ (function (_super) {
    __extends(ValidateError, _super);
    function ValidateError(errors) {
        var _this = _super.call(this, 'form validate error, get errors by error.errors') || this;
        _this.errors = {};
        _this.errors = errors;
        return _this;
    }
    return ValidateError;
}(Error));
function promisify(fn) {
    return Object.defineProperty(function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (typeof args[args.length - 1] === 'function')
            fn.apply(this, args);
        else {
            return new Promise(function (resolve, reject) {
                args[args.length] = function (err, res) {
                    if (err)
                        return reject(new ValidateError(err));
                    resolve(res);
                };
                args.length++;
                fn.apply(_this, args);
            });
        }
    }, 'name', { value: fn.name });
}
/* harmony default export */ var Form_promisify = (promisify);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Form/store.js
var store_assign = (undefined && undefined.__assign) || function () {
    store_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return store_assign.apply(this, arguments);
};
var store_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var store_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};








var Store = /** @class */ (function () {
    function Store() {
        var _this = this;
        // 表示的 Form 的提交状态而非单个字段的提交状态。
        // 只有在触发表单 reset（原生 reset，而非当前的 resetFields） 时，才会回到  init 状态（目前没有支持 form.reset，所以没有这块逻辑）
        this.submitStatus = SubmitStatus.init;
        this.registerFields = [];
        // 所有 form item value 的变动，都会通知这里注册到的 watcher
        this.registerWatchers = [];
        // 所有 form item 内部 errors, validating, touched 状态的变化，都会通知这里注册到的 watcher
        // TODO: 合并 registerWatchers
        this.registerStateWatchers = [];
        // 所有 form 整体 的变动，都会通知这里注册到的 watcher
        this.registerFormWatchers = [];
        // 和formControl 的 touched属性不一样。 只要被改过的字段，这里就会存储。并且不会跟随formControl被卸载而清除。
        // reset 的时候清除
        this.touchedFields = {};
        this.store = {};
        this.initialValues = {};
        this.callbacks = {};
        // 告知 form 状态改变，进行状态收集
        this.innerCollectFormState = function () {
            _this.notifyStateWatchers();
        };
        this.innerSetCallbacks = function (values) {
            _this.callbacks = values;
        };
        this.registerFormWatcher = function (item) {
            _this.registerFormWatchers.push(item);
            return function () {
                _this.registerFormWatchers = _this.registerFormWatchers.filter(function (x) { return x !== item; });
            };
        };
        this.registerStateWatcher = function (item) {
            _this.registerStateWatchers.push(item);
            return function () {
                _this.registerStateWatchers = _this.registerStateWatchers.filter(function (x) { return x !== item; });
            };
        };
        this.registerWatcher = function (item) {
            _this.registerWatchers.push(item);
            return function () {
                _this.registerWatchers = _this.registerWatchers.filter(function (x) { return x !== item; });
            };
        };
        // 收集所有control字段，并在组件卸载时移除
        this.registerField = function (item) {
            _this.registerFields.push(item);
            _this.notifyWatchers();
            return function () {
                _this.registerFields = _this.registerFields.filter(function (x) { return x !== item; });
                _this.notifyWatchers();
            };
        };
        // hasField为true时，只返回传入field属性的control实例
        // isFormList 目前只在校验时需要包含
        // TODO formlist 实现缺陷，待优化
        this.getRegisteredFields = function (hasField, options) {
            if (hasField) {
                return _this.registerFields.filter(function (control) { var _a; return control.hasFieldProps() && ((options === null || options === void 0 ? void 0 : options.containFormList) || !((_a = control.props) === null || _a === void 0 ? void 0 : _a.isFormList)); });
            }
            return _this.registerFields;
        };
        // 获取props.field === field 的control组件。
        this.getRegisteredField = function (field) {
            return _this.registerFields.filter(function (x) { return x.props.field === field; })[0];
        };
        // 通知所有的FormItem进行更新。
        // setFieldValue: 外部调用setFieldsValue (setFieldValue等)方法触发更新
        // innerSetValue: 控件例如Input，通过onChange事件触发的更新
        // reset：重置
        this.notify = function (type, info) {
            if (type === 'setFieldValue' || (type === 'innerSetValue' && !info.ignore)) {
                // type = reset时，在reset函数里处理
                // if info.field is a[0], get a.0
                _this._pushTouchField(info.changeValues
                    ? iterativelyGetKeys(info.changeValues)
                    : _this._getIterativelyKeysByField(info.field));
            }
            _this.registerFields.forEach(function (item) {
                item.onStoreChange &&
                    item.onStoreChange(type, store_assign(store_assign({}, info), { current: _this.store }));
            });
        };
        this.innerSetInitialValues = function (values) {
            if (!values)
                return;
            _this.initialValues = cloneDeep(values);
            Object.keys(values).forEach(function (field) {
                utils_set(_this.store, field, values[field]);
            });
        };
        this.innerSetInitialValue = function (field, value) {
            if (!field)
                return;
            _this.initialValues[field] = value;
            // 组件在创建的时候，需要判断store里存的对应field的值是否生效。只要没有被操作过（touchedFields里不存在），就生效
            if (!_this._inTouchFields(field)) {
                utils_set(_this.store, field, get_default()(_this.initialValues, field));
            }
        };
        /**
         *
         * 内部使用，更新value，会同时触发onChange 和 onValuesChange
         * @options.isFormList  强制更新field对应的组件包括其子组件,form
         */
        this.innerSetFieldValue = function (field, value, options) {
            var _a, _b, _c;
            if (!field)
                return;
            var prev = cloneDeep(_this.store);
            utils_set(_this.store, field, value);
            _this.triggerValuesChange((_a = {}, _a[field] = value, _a));
            _this.triggerTouchChange((_b = {}, _b[field] = value, _b));
            _this.notify('innerSetValue', store_assign(store_assign({ prev: prev, field: field }, options), { changeValues: (_c = {}, _c[field] = value, _c) }));
        };
        // 内部使用
        this.innerGetStore = function () {
            return _this.store;
        };
        // 目前返回提交状态，后续统一维护 errors,warnings 后，这里可进行拓展
        this.innerGetStoreStatus = function () {
            return {
                submitStatus: _this.submitStatus,
            };
        };
        // 内部使用，返回原始对象，注入到组件的 value 都从这里获取值，cloneDeep 后的值每次引用地址是不同的
        this.innerGetFieldValue = function (field) {
            return get_default()(_this.store, field);
        };
        // 获取所有被操作过的字段
        this.getTouchedFields = function () {
            return _this.getRegisteredFields(true)
                .filter(function (item) {
                return item.isTouched();
            })
                .map(function (x) { return x.props.field; });
        };
        // 外部调用设置表单字段值
        this.setFieldValue = function (field, value) {
            var _a;
            if (!field)
                return;
            _this.setFields((_a = {},
                _a[field] = { value: value },
                _a));
        };
        // 外部调用，设置多个表单控件的值
        this.setFieldsValue = function (values) {
            if ((0,is/* isObject */.Kn)(values)) {
                var fields = Object.keys(values);
                var obj_1 = {};
                fields.forEach(function (field) {
                    obj_1[field] = {
                        value: values[field],
                    };
                });
                _this.setFields(obj_1);
            }
        };
        // 外部调用，设置多个表单控件的值，以及 error，touch 信息。
        this.setFields = function (obj) {
            var fields = Object.keys(obj);
            var changeValues = {};
            fields.forEach(function (field) {
                var _a;
                var item = obj[field];
                var prev = cloneDeep(_this.store);
                if (item) {
                    var info = {};
                    if ('error' in item) {
                        info.errors = item.error;
                    }
                    if ('warning' in item) {
                        info.warnings = item.warning;
                    }
                    if ('touched' in item) {
                        info.touched = item.touched;
                    }
                    if ('value' in item) {
                        utils_set(_this.store, field, item.value);
                        changeValues[field] = item.value;
                    }
                    _this.notify('setFieldValue', {
                        data: info,
                        prev: prev,
                        field: field,
                        changeValues: (_a = {}, _a[field] = item.value, _a),
                    });
                }
            });
            _this.triggerValuesChange(changeValues);
        };
        this.getFieldValue = function (field) {
            return cloneDeep(get_default()(_this.store, field));
        };
        // 获取单个字段的错误信息。
        this.getFieldError = function (field) {
            var item = _this.getRegisteredField(field);
            return item ? item.getErrors() : null;
        };
        // 获取传入字段/全部的错误信息
        this.getFieldsError = function (fields) {
            var errors = {};
            if ((0,is/* isArray */.kJ)(fields)) {
                fields.map(function (field) {
                    var error = _this.getFieldError(field);
                    if (error) {
                        errors[field] = error;
                    }
                });
            }
            else {
                _this.getRegisteredFields(true, { containFormList: true }).forEach(function (item) {
                    if (item.getErrors()) {
                        errors[item.props.field] = item.getErrors();
                    }
                });
            }
            return errors;
        };
        this.getFields = function () {
            return cloneDeep(_this.store);
        };
        this.getFieldsValue = function (fields) {
            var values = {};
            if ((0,is/* isArray */.kJ)(fields)) {
                fields.forEach(function (key) {
                    utils_set(values, key, _this.getFieldValue(key));
                });
                return values;
            }
            _this.getRegisteredFields(true).forEach(function (_a) {
                var field = _a.props.field;
                var value = get_default()(_this.store, field);
                utils_set(values, field, value);
            });
            return values;
        };
        this.resetFields = function (fieldKeys) {
            var prev = cloneDeep(_this.store);
            var fields = (0,is/* isString */.HD)(fieldKeys) ? [fieldKeys] : fieldKeys;
            if (fields && (0,is/* isArray */.kJ)(fields)) {
                var changeValues_1 = {};
                fields.forEach(function (field) {
                    utils_set(_this.store, field, _this.initialValues[field]);
                    changeValues_1[field] = get_default()(_this.store, field);
                });
                _this.triggerValuesChange(changeValues_1);
                _this.notify('reset', { prev: prev, field: fields });
                _this._popTouchField(fields);
            }
            else {
                var newValues_1 = {};
                var changeValues_2 = cloneDeep(_this.store);
                Object.keys(_this.initialValues).forEach(function (field) {
                    utils_set(newValues_1, field, _this.initialValues[field]);
                });
                _this.store = newValues_1;
                _this.getRegisteredFields(true).forEach(function (item) {
                    var key = item.props.field;
                    utils_set(changeValues_2, key, get_default()(_this.store, key));
                });
                _this.triggerValuesChange(changeValues_2);
                _this._popTouchField();
                _this.notify('reset', { prev: prev, field: Object.keys(changeValues_2) });
            }
        };
        this.validate = Form_promisify(function (fieldsOrCallback, cb) {
            var callback = function () { };
            var controlItems = _this.getRegisteredFields(true, {
                containFormList: true,
            });
            if ((0,is/* isArray */.kJ)(fieldsOrCallback) && fieldsOrCallback.length > 0) {
                controlItems = controlItems.filter(function (x) { return fieldsOrCallback.indexOf(x.props.field) > -1; });
                callback = cb || callback;
            }
            else if (typeof fieldsOrCallback === 'function') {
                callback = fieldsOrCallback;
            }
            var promises = controlItems.map(function (x) { return x.validateField(); });
            Promise.all(promises).then(function (result) {
                var errors = {};
                var values = {};
                result.map(function (x) {
                    var _a;
                    if (x.error) {
                        errors = store_assign(store_assign({}, errors), x.error);
                    }
                    var item = _this.getRegisteredField(x.field);
                    if (!((_a = item.props) === null || _a === void 0 ? void 0 : _a.isFormList)) {
                        // 保持和 2.46.0 之前版本行为一致，避免 {users: []}
                        utils_set(values, x.field, x.value);
                    }
                });
                if (Object.keys(errors).length) {
                    var onValidateFail = _this.callbacks.onValidateFail;
                    onValidateFail && onValidateFail(errors);
                    callback && callback(errors, cloneDeep(values));
                }
                else {
                    callback && callback(null, cloneDeep(values));
                }
            });
        });
        this.toggleSubmitStatus = function (submitStatus) {
            _this.submitStatus = submitStatus;
            _this.innerCollectFormState();
            _this.notifyFormWatcher();
        };
        this.submit = function () {
            _this.toggleSubmitStatus(SubmitStatus.submitting);
            _this.validate(function (errors, values) {
                var result;
                var _a = _this.callbacks, onSubmit = _a.onSubmit, onSubmitFailed = _a.onSubmitFailed;
                if (!errors && onSubmit) {
                    result = onSubmit(values);
                }
                if (errors && onSubmitFailed) {
                    result = onSubmitFailed(errors);
                }
                _this.toggleSubmitStatus(errors ? SubmitStatus.error : SubmitStatus.success);
                if (result && result.then) {
                    // resolve 或者 reject， 都需要更新 submitting 的提交状态
                    result.catch(function (error) {
                        // 保持以前的逻辑
                        return Promise.reject(error);
                    });
                }
            });
        };
        this.getFieldsState = function (fields) {
            var result = {};
            var getItemState = function (item) {
                if (!item) {
                    return null;
                }
                var error = item.getErrors();
                return {
                    errors: error ? [error] : [],
                    warnings: item.getWarnings(),
                    validateStatus: item.getValidateStatus(),
                    isSubmitting: _this.submitStatus === SubmitStatus.submitting,
                    isTouched: item.isTouched(),
                    value: _this.getFieldValue(item.props.field),
                };
            };
            if ((0,is/* isArray */.kJ)(fields)) {
                fields.forEach(function (key) {
                    result[key] = getItemState(_this.getRegisteredField(key));
                });
                return result;
            }
            _this.getRegisteredFields(true).forEach(function (item) {
                result[item.props.field] = getItemState(item);
            });
            return result;
        };
        this.clearFields = function (fieldKeys) {
            var prev = cloneDeep(_this.store);
            var fields = (0,is/* isString */.HD)(fieldKeys) ? [fieldKeys] : fieldKeys;
            if (fields && (0,is/* isArray */.kJ)(fields)) {
                var changeValues_3 = {};
                fields.forEach(function (field) {
                    utils_set(_this.store, field, undefined);
                    changeValues_3[field] = get_default()(_this.store, field);
                });
                _this.triggerValuesChange(changeValues_3);
                _this.notify('setFieldValue', {
                    prev: prev,
                    field: fields,
                    data: {
                        errors: null,
                        warnings: null,
                    },
                });
                // this._popTouchField(fields);
            }
            else {
                var changeValues_4 = {};
                _this.store = {};
                _this.getRegisteredFields(true).forEach(function (item) {
                    var key = item.props.field;
                    utils_set(changeValues_4, key, undefined);
                });
                _this.triggerValuesChange(changeValues_4);
                // this._popTouchField();
                _this.notify('setFieldValue', {
                    prev: prev,
                    field: Object.keys(changeValues_4),
                    data: {
                        errors: null,
                        warnings: null,
                    },
                });
            }
        };
    }
    Store.prototype.notifyWatchers = function () {
        this.registerWatchers.forEach(function (item) {
            item();
        });
    };
    // 注册监听全局状态的 watcher
    Store.prototype.notifyFormWatcher = function () {
        this.registerFormWatchers.forEach(function (item) {
            item();
        });
    };
    Store.prototype.notifyStateWatchers = function () {
        this.registerStateWatchers.forEach(function (item) {
            item();
        });
    };
    Store.prototype.triggerValuesChange = function (value) {
        if (value && Object.keys(value).length) {
            var onValuesChange = this.callbacks.onValuesChange;
            onValuesChange && onValuesChange(value, this.getFields());
        }
        this.notifyWatchers();
    };
    Store.prototype.triggerTouchChange = function (value) {
        if (value && Object.keys(value).length) {
            var onChange = this.callbacks.onChange;
            onChange && onChange(value, this.getFields());
        }
    };
    Store.prototype._getIterativelyKeysByField = function (field) {
        if (!field) {
            return [];
        }
        var fields = [].concat(field);
        var keys = fields
            .map(function (item) { return iterativelyGetKeys(utils_set({}, item, undefined)); })
            .reduce(function (total, next) {
            return total.concat(next);
        }, []);
        return store_spreadArray([field], store_read(keys), false);
    };
    Store.prototype._inTouchFields = function (field) {
        var _this = this;
        var keys = this._getIterativelyKeysByField(field);
        // return fields.some((item) => has(fieldObj, item));
        return keys.some(function (item) { return has_default()(_this.touchedFields, item); });
    };
    Store.prototype._popTouchField = function (field) {
        if (field === undefined) {
            this.touchedFields = {};
        }
        var keys = this._getIterativelyKeysByField(field);
        this.touchedFields = omit_default()(this.touchedFields, keys);
    };
    Store.prototype._pushTouchField = function (field) {
        var _this = this;
        [].concat(field).forEach(function (key) {
            setWith_default()(_this.touchedFields, key, undefined, Object);
        });
    };
    return Store;
}());
/* harmony default export */ var Form_store = (Store);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Form/useForm.js


function getFormInstance() {
    var store = new Form_store();
    return {
        getFieldsValue: store.getFieldsValue,
        getFieldValue: store.getFieldValue,
        getFieldError: store.getFieldError,
        getFieldsError: store.getFieldsError,
        getTouchedFields: store.getTouchedFields,
        getFields: store.getFields,
        setFieldValue: store.setFieldValue,
        setFieldsValue: store.setFieldsValue,
        setFields: store.setFields,
        resetFields: store.resetFields,
        clearFields: store.clearFields,
        submit: store.submit,
        validate: store.validate,
        scrollToField: function () { },
        getFieldsState: store.getFieldsState,
        // arco 内部使用，业务万不可调用
        getInnerMethods: function (inner) {
            var methods = {};
            if (inner) {
                [
                    'registerField',
                    'registerWatcher',
                    'registerStateWatcher',
                    'registerFormWatcher',
                    'innerSetInitialValues',
                    'innerSetInitialValue',
                    'innerSetCallbacks',
                    'innerSetFieldValue',
                    'innerGetStore',
                    'innerGetStoreStatus',
                    'innerGetFieldValue',
                    'innerCollectFormState',
                ].map(function (key) {
                    methods[key] = store[key];
                });
            }
            return methods;
        },
    };
}
function useForm(form) {
    var formRef = (0,react.useRef)(form);
    if (!formRef.current) {
        if (form) {
            formRef.current = form;
        }
        else {
            formRef.current = getFormInstance();
        }
    }
    return [formRef.current];
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/constant.js
var constant = __webpack_require__(91702);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Form/context.js


var context_FormContext = (0,react.createContext)({
    layout: 'horizontal',
    labelCol: { span: 5, offset: 0 },
    labelAlign: 'right',
    wrapperCol: { span: 19, offset: 0 },
    requiredSymbol: true,
    getFormElementId: function () { return 'arco-'; },
    store: {
        clearFields: constant/* NOOP */.dG,
        getFieldsValue: constant/* NOOP */.dG,
        getFieldValue: constant/* NOOP */.dG,
        getFieldError: constant/* NOOP */.dG,
        getFieldsError: constant/* NOOP */.dG,
        getTouchedFields: constant/* NOOP */.dG,
        getFields: constant/* NOOP */.dG,
        setFieldValue: constant/* NOOP */.dG,
        setFieldsValue: constant/* NOOP */.dG,
        setFields: constant/* NOOP */.dG,
        resetFields: constant/* NOOP */.dG,
        submit: constant/* NOOP */.dG,
        validate: constant/* NOOP */.dG,
        getFieldsState: constant/* NOOP */.dG,
        scrollToField: constant/* NOOP */.dG,
        getInnerMethods: function () { return ({
            registerField: constant/* NOOP */.dG,
            innerGetStore: constant/* NOOP */.dG,
            registerStateWatcher: constant/* NOOP */.dG,
            registerWatcher: constant/* NOOP */.dG,
        }); },
    },
});
var context_FormItemContext = (0,react.createContext)({});
var FormProviderContext = (0,react.createContext)({});
var FormListContext = (0,react.createContext)({});

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/omit.js
var _util_omit = __webpack_require__(50049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Form/form.js
var form_assign = (undefined && undefined.__assign) || function () {
    form_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return form_assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var form_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};











function getFormElementId(prefix, field) {
    var id = field.replace(/[\[\.]/g, '_').replace(/\]/g, '');
    return prefix ? prefix + "-" + id : "" + id;
}
var defaultProps = {
    layout: 'horizontal',
    labelCol: { span: 5, offset: 0 },
    labelAlign: 'right',
    wrapperCol: { span: 19, offset: 0 },
    requiredSymbol: true,
    wrapper: 'form',
    validateTrigger: 'onChange',
};
var Form = function (baseProps, ref) {
    var _a;
    var _b, _c;
    var ctx = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_);
    var formProviderCtx = (0,react.useContext)(FormProviderContext);
    var wrapperRef = (0,react.useRef)(null);
    var _d = form_read(useForm(baseProps.form), 1), formInstance = _d[0];
    var isMount = (0,react.useRef)();
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, (_b = ctx.componentConfig) === null || _b === void 0 ? void 0 : _b.Form);
    var layout = props.layout, labelCol = props.labelCol, wrapperCol = props.wrapperCol, Wrapper = props.wrapper, id = props.id, requiredSymbol = props.requiredSymbol, labelAlign = props.labelAlign, disabled = props.disabled, colon = props.colon, className = props.className, validateTrigger = props.validateTrigger, formPrefixCls = props.prefixCls, validateMessages = props.validateMessages, rest = __rest(props, ["layout", "labelCol", "wrapperCol", "wrapper", "id", "requiredSymbol", "labelAlign", "disabled", "colon", "className", "validateTrigger", "prefixCls", "validateMessages"]);
    var prefixCls = formPrefixCls || ctx.getPrefixCls('form');
    var rtl = ctx.rtl;
    var size = 'size' in props ? props.size : ctx.size;
    var innerMethods = formInstance.getInnerMethods(true);
    if (!isMount.current) {
        innerMethods.innerSetInitialValues(props.initialValues);
    }
    (0,react.useEffect)(function () {
        isMount.current = true;
    }, []);
    (0,react.useEffect)(function () {
        var unregister;
        if (formProviderCtx.register) {
            unregister = formProviderCtx.register(props.id, formInstance);
        }
        return unregister;
    }, [props.id, formInstance]);
    (0,react.useImperativeHandle)(ref, function () {
        return formInstance;
    });
    // 滚动到目标表单字段位置
    formInstance.scrollToField = function (field, options) {
        var node = wrapperRef.current;
        var id = props.id;
        if (!node) {
            return;
        }
        var fieldNode = node.querySelector("#" + getFormElementId(id, field));
        if (!fieldNode) {
            // 如果设置了nostyle， fieldNode不存在，尝试直接查询表单控件
            fieldNode = node.querySelector("#" + getFormElementId(id, field) + ID_SUFFIX);
        }
        fieldNode &&
            (0,es/* default */.Z)(fieldNode, form_assign({ behavior: 'smooth', block: 'nearest', scrollMode: 'if-needed' }, options));
    };
    innerMethods.innerSetCallbacks({
        onValuesChange: function (value, values) {
            props.onValuesChange && props.onValuesChange(value, values);
            formProviderCtx.onFormValuesChange && formProviderCtx.onFormValuesChange(props.id, value);
        },
        onChange: props.onChange,
        onValidateFail: function (errors) {
            if (props.scrollToFirstError) {
                var options = (0,is/* isObject */.Kn)(props.scrollToFirstError) ? props.scrollToFirstError : {};
                formInstance.scrollToField(Object.keys(errors)[0], options);
            }
        },
        onSubmitFailed: props.onSubmitFailed,
        onSubmit: function (values) {
            var returnValue = props.onSubmit && props.onSubmit(values);
            formProviderCtx.onFormSubmit && formProviderCtx.onFormSubmit(props.id, values);
            return returnValue;
        },
    });
    var contextProps = {
        requiredSymbol: requiredSymbol,
        labelAlign: labelAlign,
        disabled: disabled,
        colon: colon,
        labelCol: labelCol,
        wrapperCol: wrapperCol,
        layout: layout,
        store: formInstance,
        prefixCls: prefixCls,
        validateTrigger: validateTrigger,
        validateMessages: merge_default()({}, (_c = ctx.locale.Form) === null || _c === void 0 ? void 0 : _c.validateMessages, validateMessages),
        getFormElementId: function (field) { return getFormElementId(id, field); },
    };
    var FormContext = context_FormContext;
    return (react.createElement(ConfigProvider/* default */.ZP, form_assign({}, ctx, { size: size }),
        react.createElement(FormContext.Provider, { value: contextProps },
            react.createElement(Wrapper, form_assign({ ref: wrapperRef }, (0,_util_omit/* default */.Z)(rest, [
                'form',
                'size',
                'initialValues',
                'onValuesChange',
                'onChange',
                'wrapperProps',
                'scrollToFirstError',
                'onSubmit',
                'onSubmitFailed',
            ]), props.wrapperProps, { className: (0,_util_classNames/* default */.Z)(prefixCls, prefixCls + "-" + layout, prefixCls + "-size-" + size, (_a = {}, _a[prefixCls + "-rtl"] = rtl, _a), className), style: props.style, onSubmit: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    formInstance.submit();
                }, id: id }), props.children))));
};
var FormComponent = (0,react.forwardRef)(Form);
FormComponent.displayName = 'Form';
/* harmony default export */ var Form_form = (FormComponent);

// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js
var CSSTransition = __webpack_require__(29697);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Grid/index.js + 4 modules
var Grid = __webpack_require__(79458);
// EXTERNAL MODULE: ./node_modules/lodash/isEqualWith.js
var isEqualWith = __webpack_require__(28368);
var isEqualWith_default = /*#__PURE__*/__webpack_require__.n(isEqualWith);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/warning.js
var warning = __webpack_require__(97802);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconExclamationCircleFill/index.js
var IconExclamationCircleFill = __webpack_require__(67012);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconCloseCircleFill/index.js
var IconCloseCircleFill = __webpack_require__(39911);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconCheckCircleFill/index.js
var IconCheckCircleFill = __webpack_require__(19530);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconLoading/index.js
var IconLoading = __webpack_require__(69049);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Form/control.js
var control_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var control_assign = (undefined && undefined.__assign) || function () {
    control_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return control_assign.apply(this, arguments);
};
var control_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var control_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};













/**
 * 👀 👀 👀：不要在业务中直接调用，下个大版本将不会对外导出
 */
var Control = /** @class */ (function (_super) {
    control_extends(Control, _super);
    function Control(props, context) {
        var _this = _super.call(this, props) || this;
        // 校验信息
        _this.errors = null;
        // 校验 warning 信息
        _this.warnings = null;
        _this.isDestroyed = false;
        // 保存 props.children 或函数类型 props.children() 的返回值
        _this.childrenElement = null;
        // 触发 store 进行状态收集
        // TODO: error, validateStatus ,touched 状态和 UI 组件解耦，统一维护在 store 内部
        _this.triggerStateCollect = function () {
            var innerCollectFormState = _this.context.store.getInnerMethods(true).innerCollectFormState;
            innerCollectFormState();
        };
        // 切换校验状态
        _this.toggleValidateStatus = function (status) {
            _this.validateStatus = status;
            _this.triggerStateCollect();
        };
        // 切换 touch 状态
        _this.toggleTouched = function (touched) {
            _this.touched = (0,is/* isBoolean */.jn)(touched) ? touched : !_this.touched;
            _this.triggerStateCollect();
        };
        _this.setWarnings = function (warnings) {
            _this.warnings = warnings;
            _this.triggerStateCollect();
        };
        _this.setErrors = function (errors) {
            _this.errors = errors;
            _this.triggerStateCollect();
        };
        _this.getErrors = function () {
            return _this.errors;
        };
        _this.getWarnings = function () {
            return _this.warnings || [];
        };
        _this.isTouched = function () {
            return _this.touched;
        };
        _this.getValidateStatus = function () {
            if (_this.props.validateStatus) {
                return _this.props.validateStatus;
            }
            return _this.validateStatus;
        };
        _this.hasFieldProps = function () {
            return !!_this.props.field;
        };
        _this.clearFormItemError = function (field) {
            if (field === void 0) { field = _this.props.field; }
            // destroy errors
            var updateFormItem = _this.context.updateFormItem;
            updateFormItem && updateFormItem(field, { errors: null, warnings: null });
        };
        _this.updateFormItem = function () {
            if (_this.isDestroyed)
                return;
            _this.forceUpdate();
            var updateFormItem = _this.context.updateFormItem;
            updateFormItem &&
                updateFormItem(_this.props.field, {
                    errors: _this.errors,
                    warnings: _this.warnings,
                });
        };
        _this.getFieldValue = function () {
            var field = _this.props.field;
            var store = _this.context.store;
            return field ? store.getInnerMethods(true).innerGetFieldValue(field) : undefined;
        };
        _this.onStoreChange = function (type, info) {
            var fields = (0,is/* isArray */.kJ)(info.field) ? info.field : [info.field];
            var _a = _this.props, field = _a.field, shouldUpdate = _a.shouldUpdate, dependencies = _a.dependencies;
            // isInner: the value is changed by innerSetValue
            var shouldUpdateItem = function (extra) {
                if (dependencies && shouldUpdate) {
                    (0,warning/* default */.Z)(true, '`shouldUpdate` of the `Form.Item` will be ignored.');
                }
                if (dependencies) {
                    if ((0,is/* isArray */.kJ)(dependencies) ||
                        dependencies.some(function (depField) { return isFieldMatch(depField, fields); })) {
                        if (_this.isTouched()) {
                            _this.validateField();
                        }
                    }
                }
                else if (shouldUpdate) {
                    var shouldRender = false;
                    if ((0,is/* isFunction */.mf)(shouldUpdate)) {
                        shouldRender = shouldUpdate(info.prev, info.current, control_assign({ field: info.field }, extra));
                    }
                    else {
                        shouldRender = !isEqualWith_default()(info.prev, info.current);
                    }
                    if (shouldRender) {
                        _this.updateFormItem();
                    }
                }
            };
            switch (type) {
                case 'reset':
                    _this.toggleTouched(false);
                    _this.toggleValidateStatus(undefined);
                    _this.setErrors(null);
                    _this.setWarnings(null);
                    // https://github.com/arco-design/arco-design/issues/1460
                    if (dependencies || shouldUpdate) {
                        shouldUpdateItem();
                    }
                    else {
                        // TODO
                        // Keep the previous behavior, removed in the next major release
                        _this.updateFormItem();
                    }
                    break;
                case 'innerSetValue':
                    if (isFieldMatch(field, fields)) {
                        _this.toggleTouched(true);
                        _this.updateFormItem();
                        return;
                    }
                    shouldUpdateItem({
                        isInner: true,
                        isFormList: info.isFormList,
                    });
                    break;
                case 'setFieldValue':
                    if (isFieldMatch(field, fields)) {
                        _this.toggleTouched(true);
                        if (info.data && 'touched' in info.data) {
                            _this.toggleTouched(info.data.touched);
                        }
                        if (info.data && 'warnings' in info.data) {
                            _this.setWarnings((0,is/* isNullOrUndefined */.le)(info.data.warnings) ? [] : [].concat(info.data.warnings));
                        }
                        if (info.data && 'errors' in info.data) {
                            _this.setErrors(info.data.errors);
                        }
                        else if (!isEqualWith_default()(get_default()(info.prev, field), get_default()(info.current, field))) {
                            _this.setErrors(null);
                        }
                        _this.updateFormItem();
                        return;
                    }
                    shouldUpdateItem();
                    break;
                default:
                    break;
            }
        };
        _this.innerSetFieldValue = function (field, value) {
            if (!field)
                return;
            var store = _this.context.store;
            var methods = store.getInnerMethods(true);
            methods.innerSetFieldValue(field, value);
            var changedValue = {};
            set_default()(changedValue, field, value);
            _this.props.onValuesChange &&
                _this.props.onValuesChange(changedValue, control_assign({}, store.getFieldsValue()));
        };
        /**
         *
         * @param triggerType the value of validateTrigger.
         * @returns
         */
        _this.validateField = function (triggerType) {
            var _a = _this.context, ctxValidateTrigger = _a.validateTrigger, validateMessages = _a.validateMessages;
            var _b = _this.props, field = _b.field, rules = _b.rules, validateTrigger = _b.validateTrigger;
            var value = _this.getFieldValue();
            // 进入到校验中的状态
            var gotoValidatingStatus = function () {
                var _a;
                var needUpdateItem = _this.errors || ((_a = _this.warnings) === null || _a === void 0 ? void 0 : _a.length);
                _this.toggleValidateStatus('validating');
                _this.setErrors(null);
                _this.setWarnings(null);
                needUpdateItem && _this.updateFormItem();
            };
            var _rules = !triggerType
                ? rules
                : (rules || []).filter(function (rule) {
                    var triggers = [].concat(rule.validateTrigger || validateTrigger || ctxValidateTrigger);
                    return triggers.indexOf(triggerType) > -1;
                });
            if (_rules && _rules.length && field) {
                gotoValidatingStatus();
                return schemaValidate(field, value, _rules, validateMessages).then(function (_a) {
                    var _b;
                    var error = _a.error, warning = _a.warning;
                    _this.setErrors(error ? error[field] : null);
                    _this.setWarnings(warning || null);
                    _this.toggleValidateStatus(_this.errors ? 'error' : ((_b = _this.warnings) === null || _b === void 0 ? void 0 : _b.length) ? 'warning' : 'success');
                    _this.updateFormItem();
                    return Promise.resolve({ error: error, value: value, field: field });
                });
            }
            gotoValidatingStatus();
            return Promise.resolve({ error: null, value: value, field: field });
        };
        // 每次 render 都会作为 onChange 传递给 children，需要保证引用地址不变
        // 所以 handleTrigger 需要声明在类上，并且直接作为 children.props.onChange
        _this.handleTrigger = function (_value) {
            var _a;
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var children = (_this.childrenElement || _this.props.children);
            var store = _this.context.store;
            var _b = _this.props, field = _b.field, trigger = _b.trigger, normalize = _b.normalize, getValueFromEvent = _b.getValueFromEvent;
            var value = (0,is/* isFunction */.mf)(getValueFromEvent) ? getValueFromEvent.apply(void 0, control_spreadArray([_value], control_read(args), false)) : _value;
            var normalizeValue = value;
            // break if value is instance of SyntheticEvent, 'cos value is missing
            if (isSyntheticEvent(value)) {
                (0,warning/* default */.Z)(true, 'changed value missed, please check whether extra elements is outta input/select controled by Form.Item');
                value.stopPropagation();
                return;
            }
            if (typeof normalize === 'function') {
                normalizeValue = normalize(value, store.getFieldValue(field), control_assign({}, store.getFieldsValue()));
            }
            _this.toggleTouched(true);
            _this.innerSetFieldValue(field, normalizeValue);
            _this.validateField(trigger);
            if ((0,react.isValidElement)(children) && children.props && children.props[trigger]) {
                if (!_this.props.isFormList) {
                    // https://github.com/arco-design/arco-design/issues/1886
                    (_a = children.props)[trigger].apply(_a, control_spreadArray([normalizeValue], control_read(args), false));
                }
            }
        };
        _this.getChild = function () {
            var children = _this.props.children;
            var store = _this.context.store;
            var child = children;
            if ((0,is/* isFunction */.mf)(children)) {
                child = children(store.getFields(), control_assign({}, store), _this.props.isFormList && {
                    value: _this.getFieldValue(),
                    onChange: _this.handleTrigger,
                });
            }
            _this.childrenElement = child;
            return child;
        };
        if ('initialValue' in props && _this.hasFieldProps()) {
            var innerMethods = context.store.getInnerMethods(true);
            innerMethods.innerSetInitialValue(props.field, props.initialValue);
        }
        return _this;
    }
    Control.prototype.componentDidMount = function () {
        var store = this.context.store;
        if (store) {
            var innerMethods = store.getInnerMethods(true);
            this.removeRegisterField = innerMethods.registerField(this);
        }
        this.isDestroyed = false;
    };
    Control.prototype.componentDidUpdate = function (prevProps) {
        // key 未改变，但 field 改变了，则需要把绑定在之前 prevProps.field 上的错误状态调整到 props.field
        // 一般会把 field 直接作为 control 的 key，他们会同步变动，不会触发此逻辑
        // 在 FormList 下，`FormItem` 顺序会被改变，为了保证校验状态被保留，key 不会改变但 field 和字段顺序有关
        if (prevProps.field !== this.props.field &&
            this.props._key &&
            prevProps._key === this.props._key) {
            this.updateFormItem();
            this.clearFormItemError(prevProps.field);
        }
    };
    Control.prototype.componentWillUnmount = function () {
        this.removeRegisterField && this.removeRegisterField();
        this.removeRegisterField = null;
        this.clearFormItemError();
        this.isDestroyed = true;
    };
    /**
     * 收集rules里的validateTrigger字段
     */
    Control.prototype.getValidateTrigger = function () {
        var _validateTrigger = this.props.validateTrigger || this.context.validateTrigger || 'onChange';
        var rules = this.props.rules || [];
        var result = [];
        rules.map(function (item) {
            result = result.concat(item.validateTrigger || _validateTrigger);
        });
        return Array.from(new Set(result));
    };
    Control.prototype.renderControl = function (children, id) {
        var _a;
        var _this = this;
        var _b;
        var _c = this.props, field = _c.field, _d = _c.trigger, trigger = _d === void 0 ? 'onChange' : _d, _e = _c.triggerPropName, triggerPropName = _e === void 0 ? 'value' : _e, validateStatus = _c.validateStatus, formatter = _c.formatter;
        var _f = this.context, store = _f.store, ctxDisabled = _f.disabled;
        var disabled = 'disabled' in this.props ? this.props.disabled : ctxDisabled;
        var child = react.Children.only(children);
        var childProps = {
            // used by label
            id: (0,_util_classNames/* default */.Z)(((_b = child.props) === null || _b === void 0 ? void 0 : _b.id) || (_a = {}, _a["" + id + ID_SUFFIX] = id, _a)),
        };
        this.getValidateTrigger().forEach(function (vt) {
            childProps[vt] = function (e) {
                var _a, _b;
                _this.validateField(vt);
                ((_a = child.props) === null || _a === void 0 ? void 0 : _a[vt]) && ((_b = child.props) === null || _b === void 0 ? void 0 : _b[vt](e));
            };
        });
        childProps[trigger] = this.handleTrigger;
        if (disabled !== undefined && !('disabled' in child.props)) {
            childProps.disabled = disabled;
        }
        // 保持引用地址不变，fix https://github.com/arco-design/arco-design/issues/1800
        var _value = get_default()(store.getInnerMethods(true).innerGetStore(), field);
        if ((0,is/* isFunction */.mf)(formatter)) {
            _value = formatter(_value);
        }
        childProps[triggerPropName] = _value;
        if (!validateStatus && this.errors) {
            childProps.error = true;
        }
        return react.cloneElement(child, childProps);
    };
    Control.prototype.render = function () {
        var _a = this.props, noStyle = _a.noStyle, field = _a.field, isFormList = _a.isFormList, hasFeedback = _a.hasFeedback;
        var validateStatus = this.getValidateStatus();
        var _b = this.context, prefixCls = _b.prefixCls, getFormElementId = _b.getFormElementId;
        var child = this.getChild();
        var id = this.hasFieldProps() ? getFormElementId(field) : undefined;
        if (this.hasFieldProps() && !isFormList && react.Children.count(child) === 1) {
            child = this.renderControl(child, id);
        }
        if (noStyle) {
            return child;
        }
        return (react.createElement("div", { className: prefixCls + "-item-control-wrapper" },
            react.createElement("div", { className: prefixCls + "-item-control", id: id },
                react.createElement("div", { className: prefixCls + "-item-control-children" },
                    child,
                    validateStatus && hasFeedback && (react.createElement("div", { className: prefixCls + "-item-feedback " + prefixCls + "-item-feedback-" + validateStatus },
                        validateStatus === 'warning' && react.createElement(IconExclamationCircleFill/* default */.Z, null),
                        validateStatus === 'success' && react.createElement(IconCheckCircleFill/* default */.Z, null),
                        validateStatus === 'error' && react.createElement(IconCloseCircleFill/* default */.Z, null),
                        validateStatus === 'validating' && react.createElement(IconLoading/* default */.Z, null)))))));
    };
    Control.defaultProps = {
        trigger: 'onChange',
        triggerPropName: 'value',
    };
    Control.isFormControl = true;
    Control.contextType = context_FormItemContext;
    return Control;
}(react.Component));
/* harmony default export */ var control = (Control);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconQuestionCircle/index.js
var IconQuestionCircle = __webpack_require__(97769);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Tooltip/index.js
var Tooltip = __webpack_require__(15695);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Form/form-label.js
var form_label_assign = (undefined && undefined.__assign) || function () {
    form_label_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return form_label_assign.apply(this, arguments);
};
var form_label_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};






// 标签
var FormItemLabel = function (_a) {
    var htmlFor = _a.htmlFor, showColon = _a.showColon, label = _a.label, requiredSymbol = _a.requiredSymbol, required = _a.required, rules = _a.rules, prefix = _a.prefix, tooltip = _a.tooltip;
    var isRequiredRule = (0,is/* isArray */.kJ)(rules) && rules.some(function (rule) { return rule && rule.required; });
    var symbolPosition = (0,is/* isObject */.Kn)(requiredSymbol) ? requiredSymbol.position : 'start';
    var symbolNode = (required || isRequiredRule) && !!requiredSymbol && (react.createElement("strong", { className: prefix + "-form-item-symbol" },
        react.createElement("svg", { fill: "currentColor", viewBox: "0 0 1024 1024", width: "1em", height: "1em" },
            react.createElement("path", { d: "M583.338667 17.066667c18.773333 0 34.133333 15.36 34.133333 34.133333v349.013333l313.344-101.888a34.133333 34.133333 0 0 1 43.008 22.016l42.154667 129.706667a34.133333 34.133333 0 0 1-21.845334 43.178667l-315.733333 102.4 208.896 287.744a34.133333 34.133333 0 0 1-7.509333 47.786666l-110.421334 80.213334a34.133333 34.133333 0 0 1-47.786666-7.509334L505.685333 706.218667 288.426667 1005.226667a34.133333 34.133333 0 0 1-47.786667 7.509333l-110.421333-80.213333a34.133333 34.133333 0 0 1-7.509334-47.786667l214.186667-295.253333L29.013333 489.813333a34.133333 34.133333 0 0 1-22.016-43.008l42.154667-129.877333a34.133333 34.133333 0 0 1 43.008-22.016l320.512 104.106667L412.672 51.2c0-18.773333 15.36-34.133333 34.133333-34.133333h136.533334z" }))));
    var renderTooltip = function () {
        if (!tooltip) {
            return null;
        }
        var tooltipIconClassName = prefix + "-form-item-tooltip";
        var tooltipProps = {};
        var tooltipIcon = react.createElement(IconQuestionCircle/* default */.Z, { className: tooltipIconClassName });
        if (!(0,is/* isObject */.Kn)(tooltip) || (0,react.isValidElement)(tooltip)) {
            tooltipProps = {
                content: tooltip,
            };
        }
        else {
            var _a = tooltip, icon = _a.icon, rest = form_label_rest(_a, ["icon"]);
            tooltipProps = rest;
            if (icon) {
                tooltipIcon = (0,react.isValidElement)(icon)
                    ? react.cloneElement(icon, {
                        className: (0,_util_classNames/* default */.Z)(tooltipIconClassName, icon.props.className),
                    })
                    : icon;
            }
        }
        return react.createElement(Tooltip/* default */.Z, form_label_assign({}, tooltipProps), tooltipIcon);
    };
    return label ? (react.createElement("label", { htmlFor: htmlFor && "" + htmlFor + ID_SUFFIX },
        symbolPosition !== 'end' && symbolNode,
        " ",
        label,
        renderTooltip(),
        symbolPosition === 'end' && react.createElement(react.Fragment, null,
            " ",
            symbolNode),
        showColon ? (showColon === true ? ':' : showColon) : '')) : null;
};
/* harmony default export */ var form_label = (FormItemLabel);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Form/form-item.js
var form_item_assign = (undefined && undefined.__assign) || function () {
    form_item_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return form_item_assign.apply(this, arguments);
};
var form_item_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var form_item_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var form_item_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};












var Row = Grid/* default.Row */.Z.Row;
var Col = Grid/* default.Col */.Z.Col;
// 错误提示文字
var FormItemTip = function (_a) {
    var _b;
    var prefixCls = _a.prefixCls, help = _a.help, propsErrors = _a.errors, warnings = _a.warnings;
    var errorTip = propsErrors.map(function (item, i) {
        if (item) {
            return (react.createElement("div", { key: i, role: "alert" }, item.message));
        }
    });
    var warningTip = [];
    warnings.map(function (item, i) {
        warningTip.push(react.createElement("div", { key: i, role: "alert", className: prefixCls + "-message-help-warning" }, item));
    });
    var isHelpTip = !(0,is/* isUndefined */.o8)(help) || !!warningTip.length;
    var visible = isHelpTip || !!errorTip.length;
    return (visible && (react.createElement(CSSTransition/* default */.Z, { in: visible, appear: true, classNames: "formblink", timeout: 300, unmountOnExit: true },
        react.createElement("div", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-message", (_b = {},
                _b[prefixCls + "-message-help"] = isHelpTip,
                _b)) }, !(0,is/* isUndefined */.o8)(help) ? (help) : (react.createElement(react.Fragment, null,
            errorTip.length > 0 && errorTip,
            warningTip.length > 0 && warningTip))))));
};
var Item = function (props, ref) {
    var _a, _b, _c, _d;
    var _e, _f;
    var _g = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _g.getPrefixCls, prefix = _g.prefixCls;
    var topFormContext = (0,react.useContext)(context_FormItemContext);
    var formListContext = (0,react.useContext)(FormListContext);
    var _h = form_item_read((0,react.useState)(null), 2), errors = _h[0], setErrors = _h[1];
    var _j = form_item_read((0,react.useState)(null), 2), warnings = _j[0], setWarnings = _j[1];
    var formContext = (0,react.useContext)(context_FormContext);
    var prefixCls = formContext.prefixCls || getPrefixCls('form');
    var formLayout = props.layout || formContext.layout;
    var labelAlign = props.labelAlign || formContext.labelAlign;
    var isDestroyed = (0,react.useRef)(false);
    // update error status
    var updateInnerFormItem = function (field, params) {
        if (params === void 0) { params = {}; }
        if (isDestroyed.current) {
            return;
        }
        var _a = params || {}, errors = _a.errors, warnings = _a.warnings;
        setErrors(function (innerErrors) {
            var newErrors = form_item_assign({}, (innerErrors || {}));
            if (errors) {
                newErrors[field] = errors;
            }
            else {
                delete newErrors[field];
            }
            return newErrors;
        });
        setWarnings(function (current) {
            var newVal = form_item_assign({}, (current || {}));
            if (warnings && warnings.length) {
                newVal[field] = warnings;
            }
            else {
                delete newVal[field];
            }
            return newVal;
        });
    };
    var updateFormItem = (0,is/* isObject */.Kn)(props.noStyle) && props.noStyle.showErrorTip && topFormContext.updateFormItem
        ? topFormContext.updateFormItem
        : updateInnerFormItem;
    (0,react.useEffect)(function () {
        isDestroyed.current = false;
        return function () {
            isDestroyed.current = true;
            setErrors(null);
            setWarnings(null);
        };
    }, []);
    var contextProps = form_item_assign(form_item_assign({}, formContext), { validateMessages: formContext.validateMessages &&
            formatValidateMsg(formContext.validateMessages, {
                label: props.label,
            }), prefixCls: prefixCls, updateFormItem: updateFormItem, disabled: 'disabled' in props ? props.disabled : formContext.disabled });
    var label = props.label, extra = props.extra, className = props.className, style = props.style, validateStatus = props.validateStatus, hidden = props.hidden, rest = form_item_rest(props, ["label", "extra", "className", "style", "validateStatus", "hidden"]);
    var labelClassNames = (0,_util_classNames/* default */.Z)(prefixCls + "-label-item", (_a = {},
        _a[prefixCls + "-label-item-left"] = labelAlign === 'left',
        _a));
    var errorInfo = errors ? Object.values(errors) : [];
    var warningInfo = warnings
        ? Object.values(warnings).reduce(function (total, next) { return total.concat(next); }, [])
        : [];
    var itemStatus = (0,react.useMemo)(function () {
        if (validateStatus) {
            return validateStatus;
        }
        if (errorInfo.length) {
            return VALIDATE_STATUS.error;
        }
        if (warningInfo.length) {
            return VALIDATE_STATUS.warning;
        }
        return undefined;
    }, [errors, warnings, validateStatus]);
    var hasHelp = (0,react.useMemo)(function () {
        return !(0,is/* isUndefined */.o8)(props.help) || warningInfo.length > 0;
    }, [props.help, warnings]);
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls + "-item", (_b = {},
        _b[prefixCls + "-item-error"] = hasHelp || (!validateStatus && itemStatus === VALIDATE_STATUS.error),
        _b[prefixCls + "-item-status-" + itemStatus] = itemStatus,
        _b[prefixCls + "-item-has-help"] = hasHelp,
        _b[prefixCls + "-item-hidden"] = hidden,
        _b[prefixCls + "-item-has-feedback"] = itemStatus && props.hasFeedback,
        _b), prefixCls + "-layout-" + formLayout, className);
    var cloneElementWithDisabled = function () {
        var _a, _b;
        var field = props.field, children = props.children;
        var disabled = 'disabled' in props ? props.disabled : formContext.disabled;
        if ((0,is/* isFunction */.mf)(children)) {
            return (react.createElement(control, form_item_assign({ disabled: disabled }, props, (field ? { key: field, _key: field } : {})), function () {
                var rest = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    rest[_i] = arguments[_i];
                }
                return children.apply(void 0, form_item_spreadArray([], form_item_read(rest), false));
            }));
        }
        if ((0,is/* isArray */.kJ)(children)) {
            var childrenDom = react.Children.map(children, function (child, i) {
                var key = ((0,is/* isObject */.Kn)(child) && child.key) || i;
                var existChildDisabled = (0,is/* isObject */.Kn)(child) && 'disabled' in child.props;
                var childProps = !(0,is/* isUndefined */.o8)(disabled) && !existChildDisabled ? { key: key, disabled: disabled } : { key: key };
                return (0,is/* isObject */.Kn)(child) ? (0,react.cloneElement)(child, childProps) : child;
            });
            return (react.createElement(control, form_item_assign({}, props, { field: undefined }), childrenDom));
        }
        if (react.Children.count(children) === 1) {
            if (field) {
                var key = ((_a = formListContext === null || formListContext === void 0 ? void 0 : formListContext.getItemKey) === null || _a === void 0 ? void 0 : _a.call(formListContext, field)) || field;
                return (react.createElement(control, form_item_assign({ disabled: disabled }, props, { key: key, _key: key }), children));
            }
            if ((0,is/* isObject */.Kn)(children)) {
                // Compatible Form.Control
                if ((_b = children.type) === null || _b === void 0 ? void 0 : _b.isFormControl) {
                    return children;
                }
                var existChildDisabled = 'disabled' in children.props;
                var childProps = !existChildDisabled && !(0,is/* isUndefined */.o8)(disabled) ? { disabled: disabled } : null;
                return (react.createElement(control, form_item_assign({}, props, { field: undefined }), !childProps ? children : (0,react.cloneElement)(children, childProps)));
            }
        }
        return children;
    };
    var FormItemContext = context_FormItemContext;
    var newFormContext = form_item_assign({}, formContext);
    if (!props.noStyle) {
        newFormContext.wrapperCol = undefined;
        newFormContext.labelCol = undefined;
    }
    return (react.createElement(context_FormContext.Provider, { value: newFormContext },
        react.createElement(FormItemContext.Provider, { value: contextProps }, props.noStyle ? (cloneElementWithDisabled()) : (react.createElement(Row, form_item_assign({ ref: ref }, (0,_util_omit/* default */.Z)(rest, [
            'tooltip',
            'children',
            'prefixCls',
            'store',
            'initialValue',
            'field',
            'labelCol',
            'wrapperCol',
            'colon',
            'disabled',
            'rules',
            'trigger',
            'triggerPropName',
            'validateTrigger',
            'noStyle',
            'required',
            'hasFeedback',
            'help',
            'normalize',
            'formatter',
            'getValueFromEvent',
            'shouldUpdate',
            'field',
            'isInner',
            'labelAlign',
            'layout',
            'requiredSymbol',
            'isFormList',
        ]), { className: classNames, div: formLayout !== 'horizontal', style: style }),
            label ? (react.createElement(Col, form_item_assign({}, (props.labelCol || formContext.labelCol), { className: (0,_util_classNames/* default */.Z)(labelClassNames, (_e = props.labelCol) === null || _e === void 0 ? void 0 : _e.className, (_f = formContext.labelCol) === null || _f === void 0 ? void 0 : _f.className, (_c = {},
                    _c[prefixCls + "-label-item-flex"] = !props.labelCol && !formContext.labelCol,
                    _c)) }),
                react.createElement(form_label, { tooltip: props.tooltip, htmlFor: props.field && formContext.getFormElementId(props.field), label: label, prefix: prefix, requiredSymbol: 'requiredSymbol' in props ? props.requiredSymbol : formContext.requiredSymbol, required: props.required, rules: props.rules, showColon: 'colon' in props ? props.colon : formContext.colon }))) : null,
            react.createElement(Col, form_item_assign({ className: (0,_util_classNames/* default */.Z)(prefixCls + "-item-wrapper", (_d = {},
                    _d[prefixCls + "-item-wrapper-flex"] = !props.wrapperCol && !formContext.wrapperCol,
                    _d)) }, (props.wrapperCol || formContext.wrapperCol)),
                cloneElementWithDisabled(),
                react.createElement(FormItemTip, { prefixCls: prefixCls, help: props.help, errors: errorInfo, warnings: warningInfo }),
                extra && react.createElement("div", { className: prefixCls + "-extra" }, extra)))))));
};
var ItemComponent = (0,react.forwardRef)(Item);
ItemComponent.defaultProps = {
    trigger: 'onChange',
    triggerPropName: 'value',
};
ItemComponent.displayName = 'FormItem';
/* harmony default export */ var form_item = (ItemComponent);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Form/form-list.js
var form_list_assign = (undefined && undefined.__assign) || function () {
    form_list_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return form_list_assign.apply(this, arguments);
};
var form_list_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var form_list_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};







var isIndexLegal = function (index, value) {
    return !(0,is/* isUndefined */.o8)(index) && index >= 0 && index < value.length;
};
var List = function (props) {
    var field = props.field, children = props.children, initialValue = props.initialValue;
    var keysRef = (0,react.useRef)({
        id: 0,
        keys: [],
    });
    var extra = 'initialValue' in props ? { initialValue: initialValue } : {};
    var currentKeys = keysRef.current.keys;
    return (react.createElement(FormListContext.Provider, { value: {
            getItemKey: function (fieldKey) {
                var keys = fieldKey === null || fieldKey === void 0 ? void 0 : fieldKey.replace(/\[|\]/g, '.').split('.');
                var startIndex = keys.indexOf(field);
                var index = keys[startIndex + 1];
                return field + "_" + currentKeys.indexOf(index) + "_" + keys.slice(startIndex + 2).join('_');
            },
        } },
        react.createElement(form_item, form_list_assign({ field: field }, extra, { isFormList: true, rules: props.rules, wrapperCol: { span: 24 }, noStyle: 'noStyle' in props ? props.noStyle : !props.rules, shouldUpdate: function (prev, current, info) {
                var _a, _b;
                if (info && !info.isInner && isFieldMatch(info.field, [field])) {
                    if (((_a = get_default()(prev, field)) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = get_default()(current, field)) === null || _b === void 0 ? void 0 : _b.length)) {
                        // 长度不一致才需要整体渲染，如 form.setfieldsValue('a.100', 'xx')
                        // 修改了某一项的话直接叫给对应的 FormItem 渲染即可
                        return true;
                    }
                }
                return false;
            } }), function (_, store, _a) {
            var _value = _a.value, onChange = _a.onChange;
            var value = _value || [];
            // 为啥 add，move，remove 里不直接用 value，而是又 getFieldValue？
            // 因为用户可能把 add，remove，move 给 memo 了，导致 remove 直接读取的 value 不是最新的
            // 保持和 2.46.0 以前的版本一致
            var add = function (defaultValue, index) {
                var _a;
                if (isSyntheticEvent(defaultValue)) {
                    (0,warning/* default */.Z)(true, 'Form.List: The event object cannot be used as a parameter of the add method');
                    return;
                }
                var value = ((_a = store.getInnerMethods(true)) === null || _a === void 0 ? void 0 : _a.innerGetFieldValue(field)) || [];
                var key = keysRef.current.id;
                keysRef.current.id += 1;
                var oldValue = value || [];
                var newValue = oldValue;
                if (index !== undefined && index >= 0 && index <= oldValue.length) {
                    currentKeys.splice(index, 0, key);
                    newValue = form_list_spreadArray(form_list_spreadArray(form_list_spreadArray([], form_list_read(oldValue.slice(0, index)), false), [defaultValue], false), form_list_read(oldValue.slice(index)), false);
                }
                else {
                    currentKeys.push(key);
                    newValue = form_list_spreadArray(form_list_spreadArray([], form_list_read(oldValue), false), [defaultValue], false);
                }
                // defaultValue = undefined 时，认为当前字段未被操作过
                onChange(newValue, {
                    isFormList: true,
                    ignore: defaultValue === undefined,
                });
            };
            var remove = function (index) {
                var _a;
                var value = ((_a = store.getInnerMethods(true)) === null || _a === void 0 ? void 0 : _a.innerGetFieldValue(field)) || [];
                var newValue = value.filter(function (_, i) { return i !== index; });
                currentKeys.splice(index, 1);
                onChange(form_list_spreadArray([], form_list_read(newValue), false), { isFormList: true });
            };
            var move = function (fromIndex, toIndex) {
                var _a;
                var value = ((_a = store.getInnerMethods(true)) === null || _a === void 0 ? void 0 : _a.innerGetFieldValue(field)) || [];
                if (fromIndex === toIndex ||
                    !isIndexLegal(fromIndex, value) ||
                    !isIndexLegal(toIndex, value)) {
                    return;
                }
                var fromId = currentKeys[fromIndex];
                currentKeys.splice(fromIndex, 1);
                currentKeys.splice(toIndex, 0, fromId);
                var fromItem = value[fromIndex];
                var newValue = form_list_spreadArray([], form_list_read(value), false);
                newValue.splice(fromIndex, 1);
                newValue.splice(toIndex, 0, fromItem);
                onChange(newValue, { isFormList: true });
            };
            return ((0,is/* isFunction */.mf)(children) &&
                children(value.map(function (_, index) {
                    var key = currentKeys[index];
                    if (key === undefined) {
                        key = keysRef.current.id;
                        currentKeys.push(key);
                        keysRef.current.id += 1;
                    }
                    return {
                        field: field + "[" + index + "]",
                        key: key,
                    };
                }), {
                    add: add,
                    remove: remove,
                    move: move,
                }));
        })));
};
List.displayName = 'FormList';
/* harmony default export */ var form_list = (List);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Form/form-provider.js


var FormProviderComponent = function (props, _) {
    var formsRef = (0,react.useRef)({});
    var register = (0,react.useCallback)(function (name, form) {
        if (name) {
            formsRef.current[name] = form;
        }
        return function () {
            delete formsRef.current[name];
        };
    }, []);
    var onFormSubmit = (0,react.useCallback)(function (name, changedValues) {
        props.onFormSubmit &&
            props.onFormSubmit(name, changedValues, {
                forms: formsRef.current,
            });
    }, [props.onFormSubmit]);
    var onFormValuesChange = (0,react.useCallback)(function (name, values) {
        props.onFormValuesChange &&
            props.onFormValuesChange(name, values, {
                forms: formsRef.current,
            });
    }, [props.onFormValuesChange]);
    return (react.createElement(FormProviderContext.Provider, { value: {
            onFormValuesChange: onFormValuesChange,
            onFormSubmit: onFormSubmit,
            register: register,
        } }, props.children));
};
var FormProvider = (0,react.forwardRef)(FormProviderComponent);
FormProvider.displayName = 'FormProvider';
/* harmony default export */ var form_provider = (FormProvider);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Form/hooks/useWatch.js
var useWatch_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};





var useWatch = function (field, form) {
    var formCtx = (0,react.useContext)(context_FormContext);
    var formInstance = form || formCtx.store;
    var _a = useWatch_read((0,react.useState)(function () {
        var fieldValues = formInstance === null || formInstance === void 0 ? void 0 : formInstance.getFieldsValue([].concat(field));
        if ((0,is/* isString */.HD)(field)) {
            return get_default()(fieldValues, field);
        }
        return fieldValues;
    }), 2), value = _a[0], setValue = _a[1];
    //  if field change, get the real value from fieldRef.current
    var fieldRef = (0,react.useRef)(field);
    fieldRef.current = field;
    var valueRef = (0,react.useRef)(JSON.stringify(value));
    (0,react.useEffect)(function () {
        if (!formInstance) {
            (0,warning/* default */.Z)(true, 'formInstance is not available');
            return;
        }
        var registerWatcher = (formInstance === null || formInstance === void 0 ? void 0 : formInstance.getInnerMethods(true)).registerWatcher;
        var updateValue = function () {
            var field = fieldRef.current;
            var formValues = formInstance.getFieldsValue([].concat(field));
            var newValue = formValues;
            if (!(0,is/* isArray */.kJ)(field)) {
                newValue = get_default()(formValues, field);
            }
            var newValueString = JSON.stringify(newValue);
            if (valueRef.current !== newValueString) {
                setValue(newValue);
                valueRef.current = newValueString;
            }
        };
        updateValue();
        var cancelWatch = registerWatcher && registerWatcher(updateValue);
        return function () {
            cancelWatch && cancelWatch();
        };
    }, []);
    return value;
};
/* harmony default export */ var hooks_useWatch = (useWatch);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Form/hooks/useContext.js
var useContext_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




/**
 * useFormContext 只会返回一些 Form 全局的状态，避免返回某个表单项的状态
 */
var useFormContext = function () {
    var formCtx = (0,react.useContext)(context_FormContext);
    var formInstance = formCtx.store;
    var _a = useContext_read((0,react.useState)(false), 2), isSubmitting = _a[0], setIsSubmitting = _a[1];
    var setSubmitting = (0,react.useCallback)(function () {
        var submitStatus = (formInstance === null || formInstance === void 0 ? void 0 : formInstance.getInnerMethods(true).innerGetStoreStatus()).submitStatus;
        var newIsSubmitting = submitStatus === SubmitStatus.submitting;
        if (isSubmitting !== newIsSubmitting) {
            setIsSubmitting(newIsSubmitting);
        }
    }, [isSubmitting]);
    (0,react.useEffect)(function () {
        if (!formInstance) {
            (0,warning/* default */.Z)(true, 'formInstance is not available');
            return;
        }
        var registerFormWatcher = (formInstance === null || formInstance === void 0 ? void 0 : formInstance.getInnerMethods(true)).registerFormWatcher;
        var update = function () { return setSubmitting(); };
        update();
        var cancelWatch = registerFormWatcher && registerFormWatcher(update);
        return function () {
            cancelWatch && cancelWatch();
        };
    }, []);
    return {
        form: formInstance,
        disabled: formCtx.disabled,
        isSubmitting: isSubmitting,
    };
};
/* harmony default export */ var useContext = (useFormContext);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Form/hooks/useState.js
var useState_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




// 获取指定 field 的内部状态，参数必填！！
var useFormState = function (field, form) {
    var formCtx = (0,react.useContext)(context_FormContext);
    var formInstance = form || formCtx.store;
    //  if field change, get the real value from fieldRef.current
    var fieldRef = (0,react.useRef)(field);
    fieldRef.current = field;
    var getFieldStateFromStore = (0,react.useCallback)(function () {
        var field = fieldRef.current;
        var formState = formInstance.getFieldsState([field]);
        return formState === null || formState === void 0 ? void 0 : formState[field];
    }, []);
    var _a = useState_read((0,react.useState)(getFieldStateFromStore), 2), formState = _a[0], setFormState = _a[1];
    var formStateRef = (0,react.useRef)(formState);
    (0,react.useEffect)(function () {
        if (!formInstance) {
            (0,warning/* default */.Z)(true, 'formInstance is not available');
            return;
        }
        var registerStateWatcher = (formInstance === null || formInstance === void 0 ? void 0 : formInstance.getInnerMethods(true)).registerStateWatcher;
        var updateState = function () {
            var newValue = getFieldStateFromStore();
            if (!isEqualWith_default()(formStateRef.current, newValue)) {
                setFormState(newValue);
                formStateRef.current = newValue;
            }
        };
        updateState();
        var cancelWatch = registerStateWatcher && registerStateWatcher(updateState);
        return function () {
            cancelWatch && cancelWatch();
        };
    }, []);
    return formState;
};
/* harmony default export */ var useState = (useFormState);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Form/index.js









var FormComp = Form_form;
FormComp.Provider = form_provider;
FormComp.Item = form_item;
FormComp.List = form_list;
FormComp.Control = control;
FormComp.useForm = useForm;
FormComp.useFormContext = useContext;
FormComp.useWatch = hooks_useWatch;
FormComp.useFormState = useState;
/* harmony default export */ var es_Form = (FormComp);


/***/ }),

/***/ 21078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isFlattenable = __webpack_require__(37285);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 14259:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 57406:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    last = __webpack_require__(10928),
    parent = __webpack_require__(40292),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ 60696:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPlainObject = __webpack_require__(66827);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ 99021:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var flatten = __webpack_require__(85564),
    overRest = __webpack_require__(45357),
    setToString = __webpack_require__(30061);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ 37285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 40292:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786),
    baseSlice = __webpack_require__(14259);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ 53888:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(85990);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
}

module.exports = cloneDeepWith;


/***/ }),

/***/ 85564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 10928:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 57557:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    baseClone = __webpack_require__(85990),
    baseUnset = __webpack_require__(57406),
    castPath = __webpack_require__(71811),
    copyObject = __webpack_require__(98363),
    customOmitClone = __webpack_require__(60696),
    flatRest = __webpack_require__(99021),
    getAllKeysIn = __webpack_require__(46904);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ 36968:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSet = __webpack_require__(10611);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),

/***/ 31921:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSet = __webpack_require__(10611);

/**
 * This method is like `_.set` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.setWith(object, '[0][1]', 'a', Object);
 * // => { '0': { '1': 'a' } }
 */
function setWith(object, path, value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : baseSet(object, path, value, customizer);
}

module.exports = setWith;


/***/ })

}]);